import { createContext, useContext } from "react";

const EditorMainPageContext = createContext(null);

export const EditorMainPageProvider = ({ value, children }) => {
  return (
    <EditorMainPageContext.Provider value={value}>
      {children}
    </EditorMainPageContext.Provider>
  );
};

export const useEditorMainPageContext = () => {
  const context = useContext(EditorMainPageContext);

  if (!context) {
    throw new Error(
      "useEditorMainPageContext must be used within EditorMainPageProvider",
    );
  }

  return context;
};

export default EditorMainPageContext;
